import { Button, ClickAwayListener, MenuItem, MenuList, Paper, Popper, withStyles } from '@material-ui/core';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';
import * as React from 'react';
import { compose } from 'redux';
import styles from './styles';
import { arrayOf, bool, func, object, string } from 'prop-types';
import clsx from 'clsx';


export const DropDownMenu = ({
    classes,
    customClasses = {},
    data,
    disabled,
    id,
    label,
    value,
    handleChange,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClickMenu = (event) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleMenuItemClick = (uuid) => {
    handleChange(uuid);
    setAnchorEl(null);
  };

  const clickAwayListener = (event) => {
    //ignore clicks on menu button
    if (anchorEl && anchorEl.contains(event.target)) {
      return;
    }
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const collapseSVG = <path d="M12.023 7.04426L19.1319 13.9239C19.6227 14.3988 19.6227 15.1689 19.1319 15.6438C18.6412 16.1187 17.8455 16.1187 17.3547 15.6438L11.9771 10.4397L6.6453 15.5995C6.15453 16.0745 5.35884 16.0745 4.86808 15.5995C4.37731 15.1246 4.37731 14.3546 4.86808 13.8796L11.977 7L12.0229 7.04442L12.023 7.04426Z" />;
  const expandSVG = <path d="M12.023 16.9557L12.0229 16.9556L11.977 17L4.86808 10.1204C4.37731 9.64543 4.37731 8.87541 4.86808 8.40047C5.35884 7.92553 6.15453 7.92553 6.6453 8.40047L11.9771 13.5603L17.3547 8.3562C17.8455 7.88127 18.6412 7.88127 19.1319 8.3562C19.6227 8.83114 19.6227 9.60117 19.1319 10.0761L12.023 16.9557Z" />;
  const CollapseIcon = createSvgIcon(collapseSVG, 'collapse');
  const ExpandIcon = createSvgIcon(expandSVG, 'expand');
  const renderButtonLabel = () => {
    if (value) {
      return data.find(item => item.uuid === value).name;
    }
    return label;
  };
  return (
    <div data-apim-test={`${id}`} >
      <ClickAwayListener onClickAway={clickAwayListener}>
        <div>
          <Button
            ref={anchorEl}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup={'true'}
            disabled={disabled}
            endIcon={open ? <CollapseIcon /> : <ExpandIcon />}
            data-apim-test={`${id}-button`}
            onClick={e => handleClickMenu(e)}
            className={classes.menuButton}
          >
            {renderButtonLabel()}
          </Button>
          <Popper
            className={clsx(classes.popper, customClasses.popper)}
            open={open}
            anchorEl={anchorEl}
            role={undefined}
            transition
            data-apim-test={`${id}-popper`}
            disablePortal
            placement={'bottom-start'}
            modifiers={{
              preventOverflow: {
                enabled: false,
                boundariesElement: 'viewport',
              },
            }}
          >
            <Paper
              classes={{
                  root: classes.MenuPaper,
              }}
            >
              <MenuList
                id="role-menu"
                classes={{
                  root: clsx(classes.MenuList, customClasses.menuListRoot),
                }}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'lock-button',
                  role: 'listbox',
                }}
                title='Role'
              >
                {data.map(item => (
                  <MenuItem
                    disabled={item.disabled}
                    key={item.uuid}
                    selected={item.uuid === value}
                    onClick={() => handleMenuItemClick(item.uuid)}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </MenuList>
            </Paper>
          </Popper>
        </div>
      </ClickAwayListener>
    </div>
  );
}
DropDownMenu.propTypes = {
  classes: object,
  customClasses: object,
  data: arrayOf(object),
  disabled: bool,
  handleChange: func,
  id: string,
  label: string,
  value: string,
};
export default compose(
    withStyles(styles),
  )(DropDownMenu);
